import DIMENSIONS from "./dimensions";
import METRICS from "./metrics";

export default { ...DIMENSIONS, ...METRICS };
